import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLinkSlant = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.41411 6.58568L6.58568 9.41411M7.05709 4.22866L7.52849 3.75726C8.83024 2.45551 10.9408 2.45551 12.2425 3.75726C13.5443 5.059 13.5443 7.16955 12.2425 8.4713L11.7711 8.9427M4.22866 7.05709L3.75726 7.52849C2.45551 8.83024 2.45551 10.9408 3.75726 12.2425C5.059 13.5443 7.16955 13.5443 8.4713 12.2425L8.9427 11.7711",
		stroke: "#EA580C",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgLinkSlant);
export default ForwardRef;
